exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar[data-v-947bb8dc]{--avatar-background:var(--yank);--avatar-border:transparent}.avatar[data-v-947bb8dc]:focus,.avatar[data-v-947bb8dc]:hover{--avatar-border:var(--payne-fire)}.avatar[data-v-947bb8dc]:focus{--avatar-background:var(--payne-fire)}.avatar[data-v-947bb8dc]{display:flex;justify-content:center;align-items:center;width:42px;height:42px;color:#fff;background-color:var(--avatar-background);border:2px solid;border-color:var(--avatar-border);border-radius:50%;transition:background .24s,border .24s}svg[data-v-947bb8dc]{width:16px}", ""]);

// exports
